<div class="kpi-wrapper">
    @for (config of kpiConfigs(); track $index) {
        <app-ui-main-kpi-widget [config]="config"></app-ui-main-kpi-widget>
    }
</div>